<template>
	<!-- `product-card-picture` mirrors base: a styling hook only. -->
	<div
		class="product-card-picture"
		:class="`relative ${pictureSize} overflow-hidden`"
	>
		<div class="flex items-center justify-center h-full w-full">
			<img
				v-if="currentImageIsNorce"
				:src="currentImageSrc"
				:srcset="currentImageSrcset"
				:sizes="imageSizes"
				:alt="alt"
				class="w-full aspect-[2/3] object-cover cursor-pointer"
				:loading="lazyLoading ? 'lazy' : 'eager'"
				:fetchpriority="lazyLoading ? 'auto' : 'high'"
				width="364"
				height="546"
			/>
			<NuxtImg
				v-else
				:src="currentImageSrc"
				:alt="alt"
				class="w-full aspect-[2/3] object-cover cursor-pointer"
				:loading="lazyLoading ? 'lazy' : 'eager'"
				:fetchpriority="lazyLoading ? 'auto' : 'high'"
				:preload="!lazyLoading"
				:sizes="imageSizes"
				width="364"
				height="546"
				:provider="currentImageProvider"
			/>
		</div>
		<ApplicationFlag
			v-for="(flagId, index) in productFlags"
			:key="flagId"
			:data="getFlagData(flagId)"
			:position="getItemPosition(flagId, index)"
			class="px-1"
		/>
	</div>
</template>

<script setup lang="ts">
import type { ApplicationFlag } from "~/types/storyblok/storyblok";
import type { ProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { FilteredProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";

interface Props {
	product: Partial<FilteredProductItem> | ProductItem;
	pictureSize: string;
	pictureAspectRatio?: string;
	lazyLoading?: boolean;
	currentImageSrc: string;
	currentImageSrcset?: string;
	currentImageIsNorce?: boolean;
	currentImageProvider?: string;
	productFlags: string[];
	getItemPosition: (id: string, index: number) => string;
	getFlagData: (id: string) => ApplicationFlag | undefined;
}

const props = defineProps<Props>();

const alt = computed(() => props.product?.Name || "Default product image");
const imageSizes = "(max-width: 1023px) 50vw, 100vw";
</script>
